import PropTypes from 'prop-types';
import React from 'react';
import FullScreenOverlay from 'app/components/deprecated/shared/FullScreenOverlay';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import './AddTitleOverlay.scss';

// this Component is used to add styling to the AddTitle component
export function AddTitleOverlay(props) {
  return (
    <FullScreenOverlay
      open={props.open}
      handleClose={props.handleClose}
      handleFocusOnRestore={props.handleFocusOnRestore}
      className="cp-add-title-overlay"
    >
      {props.children}
    </FullScreenOverlay>
  );
}

AddTitleOverlay.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  children: childrenShape,
  handleFocusOnRestore: PropTypes.func
};

export default AddTitleOverlay;
